import { useTranslation } from "react-i18next";
import { Divider, Form, Grid, GridColumn, Icon, Modal } from "semantic-ui-react";

import { Can } from "components";
import { createFormHelper } from "lib/Form";
import { ACL_ACTIVITIES } from "models";

import type { CreateApiKeyFormPayload } from "modules/AccessKeysDashboard/components/CreateApiKeyModal";

type CreateApiKeyModalFormProps = {
  hasErrors: boolean;
  isCreateAccountPending: boolean;
  onClose: () => void;
  onSubmit: (values: CreateApiKeyFormPayload) => void;
};

const FormHelper = createFormHelper<CreateApiKeyFormPayload>();

export const CreateApiKeyModalForm = ({ hasErrors, onClose, onSubmit, isCreateAccountPending }: CreateApiKeyModalFormProps) => {
  const { t } = useTranslation();
  const { watch, handleSubmit } = FormHelper.useFormContext();
  const [contact, email, phone, purpose, keyName] = watch(["contact", "email", "phone", "purpose", "keyName"]);

  return (
    <>
      <Modal.Header className="padding-container">
        <div className="header-container">
          <span className="header-title"> {t("v8_create_new_api_key", "Create new API Key")} </span>
        </div>
      </Modal.Header>
      <Divider fitted />

      <Modal.Content className="padding-container">
        <Grid columns="equal">
          <GridColumn>
            <Form.Field required error={!keyName && hasErrors}>
              <label>{t("v8_new_api_key_name", "New API key name")} </label>
              <FormHelper.Field.Input name="keyName" inputProps={{ placeholder: t("v8_name", "Name"), fluid: true }} />
            </Form.Field>
          </GridColumn>
        </Grid>

        <Grid columns="equal">
          <GridColumn>
            <Form.Field required error={!contact && hasErrors}>
              <label>{t("v8_api_key_contact_name", "API Key contact name")} </label>
              <FormHelper.Field.Input name="contact" inputProps={{ placeholder: t("v8_name", "Name"), fluid: true }} />
            </Form.Field>
          </GridColumn>
        </Grid>

        <Grid columns="equal">
          <GridColumn>
            <Form.Field required error={!email && hasErrors}>
              <label>{t("v8_api_key_contact_email", "API Key contact email")} </label>
              <FormHelper.Field.Input name="email" inputProps={{ placeholder: t("v8_email", "Email"), fluid: true }} />
            </Form.Field>
          </GridColumn>
        </Grid>

        <Grid columns="equal">
          <GridColumn>
            <Form.Field required error={!phone && hasErrors}>
              <label>{t("v8_api_key_contact_phone", "API Key contact phone")} </label>
              <FormHelper.Field.Input name="phone" inputProps={{ placeholder: t("v8_phone", "Phone"), fluid: true }} />
            </Form.Field>
          </GridColumn>
        </Grid>

        <Grid columns="equal">
          <GridColumn>
            <Form.Field required error={!purpose && hasErrors}>
              <label>{t("v8_purpose_for_api_key", "Purpose for API key")} </label>
              <FormHelper.Field.Input name="purpose" inputProps={{ placeholder: t("v8_purpose", "Purpose"), fluid: true }} />
            </Form.Field>
          </GridColumn>
        </Grid>
      </Modal.Content>
      <Divider fitted />

      <Modal.Actions className="padding-container">
        <div className="save-cancel-buttons-container">
          <Form.Button className="light" onClick={onClose}>
            {t("v8_cancel", "Cancel")}
            <Icon className="xmark" />
          </Form.Button>
          <Can I={ACL_ACTIVITIES.Create} the="publicapi">
            <Form.Button type="submit" color="green" disabled={isCreateAccountPending} loading={isCreateAccountPending} onClick={handleSubmit(d => onSubmit(d))}>
              {t("v8_save", "Save")}
              <Icon className="check" />
            </Form.Button>
          </Can>
        </div>
      </Modal.Actions>
    </>
  );
};
